import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { productUrl, sellerUrl } from "../../util/url";
import CircleLetterLogo from "../../component/circleLetterLogo/CircleLetterLogo";
import ImgSellerBadge from "../../assets/icon_seller_badge.png";
import { convertCommaNumber, openAppAndAction } from "../../util/util";
import { useAppInstallModal } from "../../store/useAppInstallModal";
import SellerCardGridProducts from "./SellerCardGridProducts";

const SellerCard = ({ seller }) => {
  if (!seller || !seller.user) return null;

  const { openModal } = useAppInstallModal();
  const products = seller.products || [];
  const mainProduct = products[0];
  const gridProducts = products.slice(1, 5);
  const showBadge = seller.is_certified;

  const handleOnClickPopup = () => {
    openAppAndAction(() => openModal(null), null, 1000);
  };

  return (
    <div className="seller-card">
      <div className="seller-header">
        <Link to={sellerUrl(seller)} className="seller-info">
          <CircleLetterLogo
            logo={seller.user.resizedSmallImage}
            name={seller.user.nickname}
            size={48}
          />
          <div className="seller-details">
            <h2 className="seller-name">
              {seller.user.nickname}
              {showBadge && (
                <img
                  src={ImgSellerBadge}
                  alt="seller_badge"
                  className="img-seller-badge"
                />
              )}
            </h2>
            <div className="seller-stats">
              <span className="follower-count">
                팔로워 {convertCommaNumber(seller.user.follower_count || 0)}명
              </span>
              <span className="review-count">
                리뷰 {(seller.rating || 0).toFixed(1)}(
                {seller.review_count || 0})
              </span>
            </div>
          </div>
        </Link>
        <button
          type="button"
          className="follow-button"
          onClick={handleOnClickPopup}
        >
          팔로우
        </button>
      </div>

      <div className="seller-products-5split">
        <div className="main-product">
          {mainProduct &&
            mainProduct.resizedSmallImages &&
            mainProduct.resizedSmallImages[0] && (
              <Link to={productUrl(mainProduct)} className="product-thumbnail">
                <img
                  src={mainProduct.resizedSmallImages[0]}
                  alt={mainProduct.title}
                  className="product-image"
                />
              </Link>
            )}
        </div>
        <SellerCardGridProducts gridProducts={gridProducts} seller={seller} />
      </div>
    </div>
  );
};

SellerCard.propTypes = {
  seller: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    is_certified: PropTypes.bool,
    user: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nickname: PropTypes.string,
      resizedSmallImage: PropTypes.string,
      follower_count: PropTypes.number,
    }),
    review_count: PropTypes.number,
    rating: PropTypes.number,
    products: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.string,
        resizedSmallImages: PropTypes.arrayOf(PropTypes.string),
      }),
    ),
  }),
};

export default SellerCard;
